export default "__VITE_ASSET__BK$a0TrU__"